import { defineMessages } from 'react-intl';

// These messages are only to be used when showSomewhatSemanticTooltips is true.
export const lightTextPaletteTooltipMessages: {
	'#006644': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#008DA6': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#00B8D9': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#0747A6': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#172B4D': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#36B37E': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#403294': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#4C6B1F': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#4C9AFF': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#6554C0': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#6A9A23': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#7F5F01': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#943D73': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#97A0AF': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#9E4C00': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#ABF5D1': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#B38600': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#B3D4FF': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#B3F5FF': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#BF2600': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#CD519D': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#D3F1A7': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#E06C00': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#EAE6FF': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FCE4A6': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FDD0EC': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FF5630': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FF991F': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FFBDAD': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FFC400': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FFF0B3': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FFFFFF': {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	'#FFFFFF': {
		id: 'fabric.theme.white',
		defaultMessage: 'White',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the white color option.',
	},
	'#B3D4FF': {
		id: 'fabric.theme.subtle-blue',
		defaultMessage: 'Subtle blue',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the subtle blue color option.',
	},
	'#B3F5FF': {
		id: 'fabric.theme.subtle-teal',
		defaultMessage: 'Subtle teal',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the subtle teal color option.',
	},
	'#ABF5D1': {
		id: 'fabric.theme.subtle-green',
		defaultMessage: 'Subtle green',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the subtle green color option.',
	},
	'#FFF0B3': {
		id: 'fabric.theme.subtle-yellow',
		defaultMessage: 'Subtle yellow',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the subtle yellow color option.',
	},
	'#FFBDAD': {
		id: 'fabric.theme.subtle-red',
		defaultMessage: 'Subtle red',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the subtle red color option.',
	},
	'#EAE6FF': {
		id: 'fabric.theme.subtle-purple',
		defaultMessage: 'Subtle purple',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the subtle purple color option.',
	},
	'#97A0AF': {
		id: 'fabric.theme.gray',
		defaultMessage: 'Gray',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the gray color option.',
	},
	'#4C9AFF': {
		id: 'fabric.theme.blue',
		defaultMessage: 'Blue',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the blue color option.',
	},
	'#00B8D9': {
		id: 'fabric.theme.teal',
		defaultMessage: 'Teal',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the teal color option.',
	},
	'#36B37E': {
		id: 'fabric.theme.green',
		defaultMessage: 'Green',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the green color option.',
	},
	'#FFC400': {
		id: 'fabric.theme.yellow',
		defaultMessage: 'Yellow',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the yellow color option.',
	},
	'#FF5630': {
		id: 'fabric.theme.red',
		defaultMessage: 'Red',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the red color option.',
	},
	'#FF991F': {
		id: 'fabric.theme.bold-orange',
		defaultMessage: 'Bold orange',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the bold orange color option.',
	},
	'#6554C0': {
		id: 'fabric.theme.purple',
		defaultMessage: 'Purple',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the purple color option.',
	},
	'#0747A6': {
		id: 'fabric.theme.bold-blue',
		defaultMessage: 'Bold blue',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the bold blue color option.',
	},
	'#008DA6': {
		id: 'fabric.theme.bold-teal',
		defaultMessage: 'Bold teal',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the bold teal color option.',
	},
	'#006644': {
		id: 'fabric.theme.bold-green',
		defaultMessage: 'Bold green',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the bold green color option.',
	},
	'#BF2600': {
		id: 'fabric.theme.bold-red',
		defaultMessage: 'Bold red',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the bold red color option.',
	},
	'#403294': {
		id: 'fabric.theme.bold-purple',
		defaultMessage: 'Bold purple',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the bold purple color option.',
	},
	'#172B4D': {
		id: 'fabric.theme.default',
		defaultMessage: 'Default',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the default color option.',
	},
	'#D3F1A7': {
		id: 'fabric.theme.subtle-lime',
		defaultMessage: 'Subtle lime',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the subtle lime color option.',
	},
	'#FDD0EC': {
		id: 'fabric.theme.subtle-magenta',
		defaultMessage: 'Subtle magenta',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the subtle magenta color option.',
	},
	'#6A9A23': {
		id: 'fabric.theme.lime',
		defaultMessage: 'Lime',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the lime color option.',
	},
	'#CD519D': {
		id: 'fabric.theme.magenta',
		defaultMessage: 'Magenta',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the magenta color option.',
	},
	'#4C6B1F': {
		id: 'fabric.theme.bold-lime',
		defaultMessage: 'Bold lime',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the bold lime color option.',
	},
	'#943D73': {
		id: 'fabric.theme.bold-magenta',
		defaultMessage: 'Bold magenta',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the bold magenta color option.',
	},
	'#B38600': {
		id: 'fabric.theme.yellow',
		defaultMessage: 'Yellow',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the yellow color option.',
	},
	'#7F5F01': {
		id: 'fabric.theme.bold-yellow',
		defaultMessage: 'Bold yellow',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the bold yellow color option.',
	},
	'#FCE4A6': {
		id: 'fabric.theme.subtle-orange',
		defaultMessage: 'Subtle orange',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the subtle orange color option.',
	},
	'#E06C00': {
		id: 'fabric.theme.orange',
		defaultMessage: 'Orange',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the orange color option.',
	},
	'#9E4C00': {
		id: 'fabric.theme.bold-orange',
		defaultMessage: 'Bold orange',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the bold orange color option.',
	},
});
